import { type FunctionComponent } from 'react';
import { Cell, Stub } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';

export type CellSelectStubProps = TestProps;

export const CellSelectStub: FunctionComponent<CellSelectStubProps> = ({
    'data-testid': dataTestId = 'CellSelectStub',
}) => (
    <Cell type="Checkbox" size="m" data-testid={dataTestId} rightPadding={false}>
        <Stub height={16} width={16} />
    </Cell>
);
